import Vue from "vue";
import Router from "vue-router";
import Group from "./views/Group.vue";

Vue.use(Router);

export default new Router({
  mode: "abstract",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "group",
      component: Group
    },
    {
      path: "/assign",
      name: "assign",
      component: () =>
        import(/* webpackChunkName: "assign" */ "./views/SelfAssign.vue")
    },
    {
      path: "/repair",
      name: "repair",
      component: () =>
        import(/* webpackChunkName: "repair" */ "./views/RepairInfo.vue")
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/notifications",
      name: "notifications",
      component: () =>
        import(
          /* webpackChunkName: "notifications" */ "./views/Notifications.vue"
        )
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue")
    },
    {
      path: "/forgotPassword",
      name: "forgotPassword",
      component: () =>
        import(
          /* webpackChunkName: "forgotPassword" */ "./views/ForgotPassword.vue"
        )
    },
    {
      path: "/changePassword",
      name: "changePassword",
      component: () =>
        import(
          /* webpackChunkName: "changePassword" */ "./views/ChangePassword.vue"
        )
    },
    {
      path: "/outstanding/map/:id",
      name: "mapOutstanding",
      component: () =>
        import(
          /* webpackChunkName: "mapOutstanding" */ "./views/OutstandingMap.vue"
        )
    },
    {
      path: "/outstanding/:id",
      name: "outstanding",
      component: () =>
        import(/* webpackChunkName: "outstanding" */ "./views/Outstanding.vue")
    },
    {
      path: "/detail/map/:id",
      name: "mapDetail",
      component: () =>
        import(/* webpackChunkName: "mapDetail" */ "./views/MapDetail.vue")
    },
    {
      path: "/detail/data/:id",
      name: "dataDetail",
      component: () =>
        import(/* webpackChunkName: "dataDetail" */ "./views/DataDetail.vue")
    }
  ]
});
